<template>
    <div
        class="mobile-navigation"
        :class="{ 'open': isMobileNavigationOpen }"
        aria-labelledby="mobile-navigation-toggler"
        role="navigation"
        itemscope
        itemtype="https://schema.org/SiteNavigationElement"
    >
        <div v-show="isNavigationInitialized">

            <ul class="acclang d-flex list-unstyled justify-content-between mb-0">
                <li class="font-weight-bold">
                    <client-only>
                        <user-login-handler id="mobile-login-change">
                        </user-login-handler>
                    </client-only>
                </li>
                <li class="list-inline-item dropdown control-languages">
                    <a data-toggle="collapse"
                       href="#mb-nav-countrySettings"
                       class="nav-link text-uppercase font-weight-bold"
                       aria-expanded="false"
                       aria-controls="mb-nav-countrySettings"
                       :aria-label="$translate('Ceres::Template.headerCountry')"
                       data-parent="#controlsList">
                        <i class="flag-icon" :class="'flag-icon-' + lang"></i>
                        {{ lang }}
                    </a>
                    <div id="mb-nav-countrySettings" class="row cmp cmp-country-settings collapse">
                        <ul class="d-flex flex-wrap">
                            <template v-for="lang in activeLanguages">
                                <li class="w-100" :class="{active: lang === activeLang}">
                                    <a class="p-3 nav-link d-inline-flex w-100"   data-update-url
                                       :href="languageUrls[lang]">
                                        <i class="flag-icon mr-2" :class="'flag-icon-' + lang"></i>
                                        {{ $translate("Ceres::Template.header" + (lang[0].toUpperCase() + lang.substring(1)) ) }}
                                    </a>
                                </li>
                            </template>
                        </ul>
                    </div>
                </li>
            </ul>

            <ul class="mobile-menu mainmenu d-block p-0 mb-0">
                <li class="mobile-img-wrapper border-0">
                    <img :src="mainCategories.images[dataContainer1MainCategory.id]" :alt="dataContainer1MainCategory.details[0].name" class="img-fluid" loading="lazy" width="1000" height="400">

                    <ul class="fs-mobile p-0 w-100 d-none"
                        :class="{ 'd-inline-flex' : (!!dataContainer1.parent) }">
                        <template v-for="mainCategory in mainCategories.main">
                            <li class="firstlvl d-block text-center font-weight-bold" :key="mainCategory.id"
                                :class="{ active : hasParentCategoryId(dataContainer1, mainCategory.id)}">
                                <a @click="slideTo(mainCategory)">{{ mainCategory.details[0].name }}</a>
                            </li>
                        </template>
                    </ul>
                </li>
                <li class="btn-close" @click="closeNavigation()" :aria-label="$translate('Ceres::Template.closeIcon')"></li>
            </ul>

            <ul class="mobile-default-menu py-3 px-5 mb-0 list-unstyled"
                :class="{ 'd-none' : (!!dataContainer1.parent) }">
                <li>
                    <h4 class="text-dark text-uppercase text-center pt-3 font-weight-bold">{{ $translate("modeherz::MobileNavigation.navigationMobileSearchProductsFor") }}</h4>
                </li>

                <template v-for="mainCategory in mainCategories.main">
                    <li class="d-block text-center font-weight-bold my-3">
                        <a class="btn btn-outline-primary w-100 text-dark py-3 text-uppercase font-weight-bold"
                           @click="slideTo(mainCategory)">{{ mainCategory.details[0].name }}</a>
                    </li>
                </template>
            </ul>

            <ul v-menu id="menu-1" class="mainmenu w-100 p-0 m-0 menu-active">

                <li class="ddown" v-if="dataContainer1.parent && dataContainer1.parent.parent"
                    @click="slideTo(dataContainer1.parent && dataContainer1.parent.parent || null, true)">
                    <span class="nav-direction btn-up">
                       <i class="fa fa-lg fa-level-up" aria-hidden="true"></i>
                    </span>
                </li>

                <li class="ddown" :class="{ invisible : dataContainer1.parent - dataContainer1.categories.length }"
                    v-for="category in dataContainer1.categories">
                    <a class="align-self-center" itemprop="name" :href="getCategoryUrl(category.url)">{{ category.details[0].name }}</a>
                    <span class="nav-direction p-0 align-self-center" v-if="category.childCount"
                          @click="slideTo(category)">
                   <i class="fa fa-lg fa-chevron-right" aria-hidden="true"></i>
                </span>
                </li>
                <li class="ddown static-link"
                    v-if="(dataContainer1.parent != null && dataContainer1.parent.id == dataContainer1MainCategory.id)">
                    <a :href="mainCategories.brands[dataContainer1MainCategory.id]" itemprop="name">{{ $translate('modeherz::Navigation.navigationBrands') }}</a>
                </li>

                <template v-if="dataContainer1.categories[0]">
                    <li class="ddown "
                        v-for="number in dataContainer1.categories[0].siblingCount - dataContainer1.categories.length">
                        <span class="nav-placeholder m-3" :style="{width: (Math.random() * 20 + 60) + '%'}"></span>
                    </li>
                </template>
                <template v-else-if="dataContainer1.parent">
                    <li class="ddown " v-for="number in dataContainer1.parent.childCount">
                        <span class="nav-placeholder m-3" :style="{width: (Math.random() * 20 + 60) + '%'}"></span>
                    </li>
                </template>
            </ul>


            <ul v-menu id="menu-2" class="mainmenu w-100 p-0 m-0">
                <li class="ddown "
                    v-if="dataContainer1.parent && dataContainer2.parent && dataContainer1.parent.parent && dataContainer2.parent.parent"
                    @click="slideTo(dataContainer2.parent && dataContainer2.parent.parent || null, true)">
                <span class="nav-direction btn-up">
                   <i class="fa fa-lg fa-level-up" aria-hidden="true"></i>
                </span>
                </li>

                <li class="ddown " v-for="category in dataContainer2.categories">
                    <a class="align-self-center" itemprop="name" :href="getCategoryUrl(category.url)">{{ category.details[0].name }}</a>
                    <span class="nav-direction p-0 align-self-center" v-if="category.childCount"
                          @click="slideTo(category)">
                   <i class="fa fa-lg fa-chevron-right" aria-hidden="true"></i>
                </span>
                </li>
                <li class="ddown static-link"
                    v-if="(dataContainer1.parent != null && dataContainer1.parent.id == dataContainer1MainCategory.id)">
                    <a :href="mainCategories.brands[dataContainer1MainCategory.id]" itemprop="name">{{ $translate('modeherz::Navigation.navigationBrands') }}</a>
                </li>

                <template v-if="dataContainer2.categories[0]">
                    <li class="ddown"
                        v-for="number in dataContainer2.categories[0].siblingCount - dataContainer2.categories.length">
                        <span class="nav-placeholder m-3" :style="{width: (Math.random() * 20 + 60) + '%'}"></span>
                    </li>
                </template>
                <template v-else-if="dataContainer2.parent">
                    <li class="ddown " v-for="number in dataContainer2.parent.childCount">
                        <span class="nav-placeholder m-3" :style="{width: (Math.random() * 20 + 60) + '%'}"></span>
                    </li>
                </template>
            </ul>

            <ul class="mainmenu w-100 p-0 m-0 menu-active">
                <template v-for="staticLink in staticLinks.links">
                    <li class="link-list list-inline-item border-0 pt-4 pl-4" :key="staticLink.categoryId">
                        <a :href="staticLink.url" itemprop="name"><i aria-hidden="true" class="mr-3 text-center fa" :class="'fa-' + staticLink.icon" ></i>{{ staticLink.name }}</a>
                    </li>
                </template>
                <li class="link-list dropdown control-hotline border-0">
                    <a :href="staticLinks.serviceUrl" class="custom_btn_reverted d-flex align-items-center justify-content-center" itemprop="name">
                        <i aria-hidden="true"
                           class="fa fa-phone-alt fa-flip-horizontal mr-3"></i>{{ $translate("modeherz::Navigation.navigationCustomerServiceBtnText") }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { MediaQueryHelper } from "../../helper/MediaQueryHelper";
import { isNullOrUndefined, isDefined } from "../../helper/utils";
import { mapState } from "vuex";

export default {

    props: {
        template: {
            default: "#vue-mobile-navigation",
            type: String
        },
        initialCategory: Object,
        breakpoints: {
            type: Array,
            default: () => ["xs", "sm", "md"]
        },
        includeLanguage: Boolean,
        staticLinks: {
            type: Object,
            required: true
        },
        mainCategories:{
            type: Object,
            required: true
        },
        languageUrls:{
            type: Object,
            required: true
        }
    },

    data()
    {
        return {
            alternativeInitialCategory:null,
            dataContainer1: {
                parent: {},
                categories: []
            },
            dataContainer2: {
                parent: {},
                categories: []
            },
            useFirstContainer: false,
            isNavigationInitialized: false,
            selectedCategory: null,
            activeLanguages: App.config.language.activeLanguages,
            activeLang: App.language
        };
    },

    computed:
    {
        breadcrumbs()
        {
            const breadcrumbs = [];
            let container = this.useFirstContainer ? this.dataContainer2 : this.dataContainer1;

            while (container && container.parent && Object.keys(container.parent).length)
            {
                breadcrumbs.unshift(
                    {
                        name: container.parent.details[0].name,
                        parent: container.parent || null
                    });

                container = container.parent;
            }

            return breadcrumbs;
        },

        dataContainer1MainCategory(){
            return this.getMainCategory(this.dataContainer1)
        },

        lang(){
            return App.language
        },

        computedInitialCategory(){
          return this.initialCategory ? this.initialCategory : this.alternativeInitialCategory
        },

        ...mapState({
            navigationTree: state => state.navigation.tree,
            isMobileNavigationOpen: state => state.navigation.isMobileNavigationOpen
        })
    },

    created()
    {
        this.$store.commit("setCurrentCategory", this.initialCategory);
    },

    mounted()
    {
        this.addEventListener();
        this.setAlternateInitialCategory();
    },

    methods:
    {
        addEventListener()
        {
            const QueryHelper = new MediaQueryHelper();
            const breakpoint = QueryHelper.getCurrentBreakpoint();

            QueryHelper.addFunction(this.loadInitialTree, this.breakpoints);

            if (this.breakpoints.includes(breakpoint))
            {
                this.loadInitialTree();
            }
        },

        setAlternateInitialCategory(){
            try{
                const id = localStorage.getItem("categories.fav");
                if(id){
                    this.alternativeInitialCategory = {id: id.split('-')[1]}
                }
            } catch(e){
                console.log('failed to access store', e);
            }
        },

        loadInitialTree()
        {
            if (this.navigationTree.length <= 0)
            {
                const categoryId = this.computedInitialCategory && this.computedInitialCategory.id ? this.computedInitialCategory.id : null;

                this.$store.dispatch("loadPartialNavigationTree", categoryId)
                    .then(response =>
                    {
                        this.$store.commit("setNavigationTree", response);
                        this.initNavigation();
                    });
            }
        },

        initNavigation()
        {
            if (this.computedInitialCategory && this.computedInitialCategory.id)
            {
                if (this.computedInitialCategory.linklist === "N")
                {
                    this.$store.commit("setCurrentCategory", this.computedInitialCategory);
                }
                else
                {
                    this.$store.dispatch("setCurrentCategoryById", { categoryId: parseInt(this.computedInitialCategory.id) });
                    this.initialSlide(this.$store.state.navigation.currentCategory);
                }
            }

            this.dataContainer1.parent = null;
            this.dataContainer1.categories = this.navigationTree;
            this.isNavigationInitialized = true;
        },

        initialSlide(currentCategory)
        {
            if (currentCategory)
            {
                if (currentCategory.children)
                {
                    this.slideTo(currentCategory);
                }
                else if (currentCategory.parent)
                {
                    this.slideTo(currentCategory.parent);
                }
            }
        },

        slideTo(category, back)
        {
            this.setMainFav(category);
            const children = isDefined(category) ? category.children : this.navigationTree;
            const categoryId = isDefined(category) ? category.id : null;

            this.loadPartialTree(categoryId);
            this.selectedCategory = category;

            if (this.useFirstContainer)
            {
                this.dataContainer1.parent = category;
                this.dataContainer1.categories = children || [];

                $("#menu-2").trigger("menu-deactivated", { back: !!back });
                $("#menu-1").trigger("menu-activated", { back: !!back });
            }
            else
            {
                this.dataContainer2.parent = category;
                this.dataContainer2.categories = children || [];

                $("#menu-1").trigger("menu-deactivated", { back: !!back });
                $("#menu-2").trigger("menu-activated", { back: !!back });
            }

            this.useFirstContainer = !this.useFirstContainer;
        },

        setMainFav(category){
            if(this.mainCategories.main.find(c => c.id === category.id)){
                let catId = "cat-" + category.id;
                try{
                    localStorage.setItem("categories.fav", catId);
                } catch(e){
                    console.log('failed to access store', e);
                }
                $("ul.mainmenu li.ddown").removeClass("fav");
                $("ul.mainmenu li.ddown").removeClass("active");
                $("#" + catId).addClass("fav");
            }
        },

        loadPartialTree(categoryId)
        {
            // eslint-disable-next-line eqeqeq
            if (this.selectedCategory != categoryId ||
                (isDefined(this.selectedCategory) && this.selectedCategory.id !== categoryId))
            {
                this.$store.dispatch("loadPartialNavigationTree", categoryId)
                    .then(response =>
                    {
                        if ((isNullOrUndefined(this.selectedCategory) && isNullOrUndefined(categoryId)) ||
                            (isDefined(this.selectedCategory) && this.selectedCategory.id === categoryId))
                        {
                            this.$store.commit("setNavigationTree", response);
                            this.updateDataContainers(categoryId);
                        }
                    });
            }
        },

        updateDataContainers(categoryId)
        {
            const containers = ["dataContainer1", "dataContainer2"];
            const category = this.getCategoryById(categoryId, this.navigationTree);

            for (const container of containers)
            {
                if (category)
                {
                    this[container].parent = category;
                    this[container].categories = category.children;
                }
                else
                {
                    // root level
                    this[container].parent = null;
                    this[container].categories = this.navigationTree;
                }
            }
        },

        getCategoryById(categoryId, tree)
        {
            for (const cat of tree)
            {
                if (categoryId === cat.id)
                {
                    return cat;
                }
                else if (cat.children)
                {
                    const foundCat = this.getCategoryById(categoryId, cat.children);

                    if (foundCat)
                    {
                        return foundCat;
                    }
                }
            }

            return null;
        },

        closeNavigation()
        {
            this.$store.commit("setIsMobileNavigationOpen", false);
        },

        getCategoryUrl(url)
        {
            const trailingSlash = url[0] === "/" ? "" : "/";
            const prefix = this.includeLanguage ? `/${App.language}${trailingSlash}` : "";

            return prefix + url;
        },

        hasParentCategoryId(category, parentCategoryId){
            if(!category){
                return false
            }
            let currentCategory = category
            while(currentCategory.parent){
                currentCategory = currentCategory.parent
                if(currentCategory.id === parentCategoryId){
                    return true
                }
            }
            return false
        },

        getMainCategory(category){
            const mainCategory = this.mainCategories.main.find(mc => this.hasParentCategoryId(this.dataContainer1, mc.id))
            return mainCategory ?? this.mainCategories.default
        }
    },

    directives:
    {
        menu: {
            bind(el)
            {
                // add "activated" classes when menu is activated
                $(el).on("menu-activated", (event, params) =>
                {
                    $(event.target).addClass("menu-active");
                    $(event.target).addClass(params.back ? "animate-in-from-left" : "animate-in-from-right");
                });
                // add "deactivated" classes when menu is deactivated
                $(el).on("menu-deactivated", (event, params) =>
                {
                    $(event.target).removeClass("menu-active");
                    $(event.target).addClass(params.back ? "animate-out-to-right" : "animate-out-to-left");
                });
                // this removes the animation class automatically after the animation has completed
                $(el).on("animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd", () =>
                {
                    $(".mainmenu").removeClass((index, className) =>
                    {
                        return (className.match(/(^|\s)animate-\S+/g) || []).join(" ");
                    });
                });
            }
        }
    }
}
</script>
